import { createContext, h } from "preact"
import { useContext, useEffect, useState } from "preact/hooks"
import fetch from "unfetch"

const Context = createContext({ loading: true })

export function VersionProvider({ children }) {
    const [context, setContext] = useState({ loading: true })
    useEffect(() => {
        fetch("/api/v4/version")
            .then((res) => res.json())
            .then((data) => setContext(data))
    }, [])

    return <Context.Provider value={context}>{children}</Context.Provider>
}

export function useVersion() {
    return useContext(Context)
}
